<template>
  <page-outline :title="$t('settings.setting_label')" icon="icon-gearwheels" colWidth="6">

    <template slot="pageContent">
      <b-row>
        <b-col>
          <div class="contactButtonContainer mt-0 mb-4" style="background-color: var(--headbandColor);box-shadow: rgba(0,0,0,0.5) 0 0 10px !important;">
            <b-row class="no-gutters justify-content-start">
              <b-col sm="4" class="pilotageTabController">
                <f7-link class="pilotageLink tabActive" v-if="currentTab === 'DP'" tab-link=".membersTab1" @click="changeCurrentTab('DP')" active>{{ $t('servicesNames.dir_pymnts') }}</f7-link>
                <f7-link class="pilotageLink tabUnactive" v-else tab-link=".membersTab1" @click="changeCurrentTab('DP')" active>{{ $t('servicesNames.dir_pymnts') }}</f7-link>
              </b-col>
              <b-col sm="4" class="pilotageTabController">
                <f7-link class="pilotageLink tabActive" v-if="currentTab === 'RTP'" tab-link=".membersTab2" @click="changeCurrentTab('RTP')">{{ $t('servicesNames.req_to_py') }}</f7-link>
                <f7-link class="pilotageLink tabUnactive" v-else tab-link=".membersTab2" @click="changeCurrentTab('RTP')">{{ $t('servicesNames.req_to_py') }}</f7-link>
              </b-col>
              <b-col sm="4" class="pilotageTabController">
                <f7-link class="pilotageLink tabActive" v-if="currentTab === 'ML'" tab-link=".membersTab3" @click="changeCurrentTab('ML')">{{ $t('servicesNames.mod_cred') }}</f7-link>
                <f7-link class="pilotageLink tabUnactive" v-else tab-link=".membersTab3" @click="changeCurrentTab('ML')">{{ $t('servicesNames.mod_cred') }}</f7-link>
              </b-col>
              <b-col sm="4" class="pilotageTabController">
                <f7-link class="pilotageLink tabActive" v-if="currentTab === 'DS'" tab-link=".membersTab4" @click="changeCurrentTab('DS')">{{ $t('servicesNames.business_docs') }}</f7-link>
                <f7-link class="pilotageLink tabUnactive" v-else tab-link=".membersTab4" @click="changeCurrentTab('DS')">{{ $t('servicesNames.business_docs') }}</f7-link>
              </b-col>
              <b-col sm="4" class="pilotageTabController">
                <f7-link class="pilotageLink tabActive" v-if="currentTab === 'MP'" tab-link=".membersTab5" @click="changeCurrentTab('MP')">{{ $t('servicesNames.marketplace') }}</f7-link>
                <f7-link class="pilotageLink tabUnactive" v-else tab-link=".membersTab5" @click="changeCurrentTab('MP')">{{ $t('servicesNames.marketplace') }}</f7-link>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <div class="col-md-12">
        <dp-settings v-if="currentTab === 'DP'" :settings="DPSettingsData"></dp-settings>
        <rtp-settings v-else-if="currentTab === 'RTP'" :settings="RTPSettingsData"></rtp-settings>
        <ml-settings v-else-if="currentTab === 'ML'" :settings="MLSettingsData"></ml-settings>
        <ds-settings v-else-if="currentTab === 'DS'" :settings="DSSettingsData"></ds-settings>
        <mp-settings v-else-if="currentTab === 'MP'" :settings="MPSettingsData"></mp-settings>
      </div>
    </template>
    <template slot="footerButtons">
      <b-row>
        <b-col md="2" offset-md="7" class="form-group">
          <f7-button class="button-action milkyBlockBlack"
            @click="changeApplicationSettings">
            <f7-icon fa="save"></f7-icon>
            <span>{{ $t('common.sve') }}</span>
          </f7-button>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>


<script>
import PageOutline from '@/components/common/PageOutline.vue'
import DPSettings from './SettingsList/DirectPaymentSettings.vue'
import RTPSettings from './SettingsList/RequestToPaySettings.vue'
import MLSettings from './SettingsList/DirectDebitSettings.vue'
import DSSettings from './SettingsList/DocumentServiceSettings.vue'
import MPSettings from './SettingsList/MarketplaceSettings.vue'
import {errorMessageAlert} from '@/helpers/alert'
import services from '@/helpers/services'
// import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'dp-settings': DPSettings,
    'rtp-settings': RTPSettings,
    'ml-settings': MLSettings,
    'ds-settings': DSSettings,
    'mp-settings': MPSettings,
    'page-outline': PageOutline
  },
  data () {
    return {
      idSettingsApplication: '',
      defaultNegotiationAllowed: false,
      negotiationActivated: true,
      defaultInstallmentNumber: 1,
      ocrActivation: false,
      validationThreshold: 0,
      isToGenerateXML: false,
      sendPaymentRequestEmail: false,
      pain001: false,
      pacs008: false,
      auto_accept_document: false,
      accept_document: false,
      decision_creancier: false,
      emailForRcv: true,
      auto_accept_payment: false,
      notif_mail_rcv_doc: false,
      email_notif_rcv_doc: false,
      max_amount: 0,
      paymentMethod: '',
      currentTab: 'DP',
      DPSettingsData: {},
      RTPSettingsData: {},
      MLSettingsData: {},
      DSSettingsData: {},
      MPSettingsData: {}
    }
  },
  created () {
    this.RTPSettingsData = {
      defaultModificationInstallmentsAllowed: '0',
      defaultNegotiationAllowed: '0',
      enableInstallmentRules: '0',
      idSettingsApplication: '',
      isToGenerateXML: '0',
      ocrActivation: '0',
      paymentMethod: '',
      sendPaymentRequestEmail: '0',
      validationThreshold: 0
    }
    this.DPSettingsData = {
      pain001: '0',
      pacs008: '0',
      decision_creancier: '0',
      ocrActivation: '0',
      emailForRcv: '1',
      auto_accept_payment: '0',
      max_amount: 0,
      idSettingsApplication: ''
    }
    this.MLSettingsData = {
      sendPaymentRequestEmail: '0',
      ocrActivation: '0',
      isToGenerateXML: '0',
      validationThreshold: 0,
      paymentMethod: '',
      enableInstallmentRules: '0',
      defaultNegotiationAllowed: '0',
      defaultModificationInstallmentsAllowed: '0'
    }
    this.DSSettingsData = {
      accept_document: '0',
      auto_accept_documents: '0',
      daysBeforeReminderAcceptation: '30',
      daysBeforeReminderPayment: '30',
      daysBetweenReminderAcceptation: '30',
      daysBetweenReminderPayment: '30',
      defaultNegotiationAllowed: '0',
      defaultReminderAcceptationActive: '0',
      defaultReminderPaymentActive: '0',
      email_notif_rcv_doc: '0',
      idSettingsApplication: '',
      isToGenerateXML: '0',
      maxNumberReminderAcceptation: '0',
      maxNumberReminderPayment: '0',
      ocrActivation: '0',
      paymentMethod: '',
      sendPaymentRequestEmail: '0',
      validationThreshold: 0
    }
    this.MPSettingsData = {
      bic_real: '',
      bic_technical: '',
      freq_statement: '0',
      iban_real: '',
      iban_technical: '',
      key_bl: '',
      key_mac: '',
      mid: '',
      payment_threshold_minus: '0',
      payment_threshold_plus: '0',
      sys_comission: '0',
      viban_liberation_time: '0',
      viban_mode: '1'
    }
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    }
  },
  mounted () {
    if (!this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.$$('.accordionForm').addClass('accordion-item-expanded')
      this.$$('.formChevron').transform('rotate(90deg)')
    }
    this.DPSettingsData = this.$engine.settings.get(services.DIRECTPAYMENTS)
    this.RTPSettingsData = this.$engine.settings.get(services.PAYMENTS)
    this.MLSettingsData = this.$engine.settings.get(services.DIRECTDEBIT)
    this.DSSettingsData = this.$engine.settings.get(services.DOCUMENTSERVICE)
    this.MPSettingsData = this.$engine.settings.get(services.SUPPLIERS)
  },
  methods: {
    rotateChevron ($event) {
      if (this.Dom7($event.target).parent().parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().hasClass('accordion-item-expanded')) {
        this.Dom7($event.target).find('i').transform('rotate(0deg)')
      } else {
        this.Dom7($event.target).find('i').transform('rotate(90deg)')
      }
    },
    changeCurrentTab (role) {
      this.currentTab = role
    },
    changeApplicationSettings () {
      let that = this
      let serviceSettings = {}
      let serviceName = ''

      if (this.currentTab === 'DP') {
        serviceSettings = this.DPSettingsData
        serviceName = 'directPayments'
      } else if (this.currentTab === 'RTP') {
        serviceSettings = this.RTPSettingsData
        serviceName = 'payments'
      } else if (this.currentTab === 'ML') {
        serviceSettings = this.MLSettingsData
        serviceName = 'directDebit'
      } else if (this.currentTab === 'DS') {
        serviceSettings = this.DSSettingsData
        serviceName = 'documentService'
      } else if (this.currentTab === 'MP') {
        serviceSettings = this.MPSettingsData
        serviceName = 'seller'
      }

      this.$engine.settings.update(serviceSettings, serviceName)
      .then(() => {
        that.$f7.modal({
          title: that.$t('settings.applctn_sttngs_mdfd'),
          text: '<span class="preloader"></span>'
        })
        setTimeout(function () {
          that.$f7.closeModal()
        }, 2000)
      })
      .catch(err => {
        errorMessageAlert(err, this)
      })
    }
  }
}
</script>
<style scoped>
.subOption {
  font-size: 14px;
}
.subOption input::-webkit-input-placeholder {
  font-size: 14px;
}


.label-switch {
  float: right;
}

.no-bullets {
    list-style-type: none;
}
.mt-2 {
  width: 100%;
}
.inputFileButton {
  float: left;
}
.list-block {
    padding: 0px 0px 0px 0px;
    margin: auto;
    width: 100%
}

.button-setting {
  width: 80px;
}
ul {
  margin-left: -35px;
}
</style>



// WEBPACK FOOTER //
// CMApplicationSettingsPage.vue?0e778fba